import type { TranslationEntity } from "./TranslationEntity";

export class CreateUpdateDisableBranchEntity {
    translations?: TranslationEntity[]
}